module.exports = __webpack_public_path__ + "static/media/button-yellow.9ca8e19e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/user-new/button-yellow.png
// module id = 791
// module chunks = 0